export default __webpack_public_path__ + "static/media/phone.0cf39f0c.png";